/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from 'styled-components';

import { useNavigate, useParams } from 'react-router-dom';
import { SideBar } from '@common/SideBar';
import { AutoAwesomeOutlined } from '@mui/icons-material';
import { Assistant } from './Assistant';
import { AIAssistant } from '@requests/telnyx';
import { AssistantTools } from './AssistantTools/AssistantTools';
import { AssistantNotSelected } from './AssistantNotSelected';
import { State, tabActions } from '@store/index';
import { useDispatch, useSelector } from 'react-redux';
import { assistantActions } from '@store/slices/assistant';

const Container = styled.div`
  display: flex;
  justify-content: center;
  overflow-y: auto;

  ::-webkit-scrollbar {
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.scrollbar.track};
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.scrollbar.thumb};
  }
`;

const Panel = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
`;

interface Props {
  assistant: AIAssistant | undefined;
  isAssistantsLoading: boolean;
}

export const AssistantTabs: React.FC<Props> = ({ assistant, isAssistantsLoading }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const createAssistant = useSelector((state: State) => state.assistant.createAssistant);

  const { service_id, tab: assistantTab } = useParams();

  const cancelAssistantCreate = () => {
    dispatch(assistantActions.createNewAssistant(null));
  };

  if (createAssistant) {
    return (
      <Container>
        <Panel>
          <SideBar
            tab='1'
            setTab={() => null}
            tabs={[
              {
                label: 'Assistant',
                value: '1',
                body: <Assistant assistant={createAssistant} isAssistantsLoading={isAssistantsLoading} />,
                disabled: false,
              },
              {
                label: 'Tools',
                value: '2',
                body: null,
                disabled: true,
              },
            ]}
            onClose={cancelAssistantCreate}
            title={'Create Assistant'}
            insetValue='2rem'
          />
        </Panel>
      </Container>
    );
  }
  if (!assistant) return <AssistantNotSelected />;

  const updateTab: React.Dispatch<string> = (tab) => {
    if (tab === '2') {
      const path = `/${service_id}/assistants/${assistant.id}/tools`;
      dispatch(tabActions.setLastMenu(path));
      navigate(path);
    } else {
      const path = `/${service_id}/assistants/${assistant.id}`;
      dispatch(tabActions.setLastMenu(path));
      navigate(path);
    }
  };

  const getTabNumber = () => {
    if (assistantTab === 'tools') return '2';
    return '1';
  };

  const tabs = [
    {
      label: 'Assistant',
      value: '1',
      body: <Assistant assistant={assistant} isAssistantsLoading={isAssistantsLoading} />,
      disabled: false,
    },
    {
      label: 'Tools',
      value: '2',
      body: <AssistantTools assistant={assistant} isAssistantsLoading={isAssistantsLoading} />,
      disabled: false,
    },
  ];

  return (
    <Container>
      <Panel>
        <SideBar
          tab={getTabNumber()}
          setTab={updateTab}
          tabs={tabs}
          onClose={() => navigate(`/${service_id}/assistants`)}
          title={assistant?.name}
          icon={<AutoAwesomeOutlined height={16} />}
          insetValue='2rem'
        />
      </Panel>
    </Container>
  );
};
